export const preloadImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};

// Preload images and resolve once they've all settled (loaded or errored).
// Useful for rendering a page in one shot without image pop-in.
export const preloadImagesAsync = (imageUrls) => {
  const urls = [...new Set((imageUrls || []).filter(Boolean))];
  return Promise.all(
    urls.map(
      (url) =>
        new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve;
          img.src = url;
        })
    )
  );
};